import React, { Component } from "react";

import Modal from "react-bootstrap/Modal";

export default class PopUpImage extends Component {
    constructor(props) {
        super(props);

        this.state = {
            show: false,
        };
    }

    componentDidMount() {
        const { show = false } = this.props;

        if(show) {
            this.setState({ show });
        }
    }

    onClose() {
        const { onClose = false } = this.props;

        if(onClose) {

            onClose();
        }
    }

    renderContent() {
        const { documentsURL = false, title } = this.props;
        let renderedContent = "";

        if (documentsURL) {
            renderedContent = (<img src={documentsURL} alt={title} style={{ width: "100%", height: "auto" }} />);
           
        }

        return renderedContent;
    }

    render() {
        const { show } = this.state;

        return (
            <Modal
                id="popup-image"
                show={show}
                backdrop={true}
                centered
                scrollable={true}
                className="popup-image"
                onHide={() => this.onClose()}
            >
                <Modal.Header closeButton />
                <Modal.Body>{this.renderContent()}</Modal.Body>
            </Modal>
        );
    }
}
